import { transport } from "@/src/config/apiConfig.js";

export default {
  async getViews(entityID, entityType) {
    try {
      let res = await transport.get(`/api/${entityType}/${entityID}/v2/views`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing get views: ", error);
      throw error;
    }
  },

  async getViewsByEntityType(entityType) {
    try {
      let res = await transport.get(`/api/views/v2`, {
        params: { entity_type: entityType },
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching views by entity type: ",
        error,
      );
      throw error;
    }
  },

  async createNewView(data) {
    try {
      let res = await transport.post(`/api/v2/views`, data);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing create new view: ",
        error,
      );
      throw error;
    }
  },

  async updateView(viewId, data) {
    try {
      let res = await transport.put(`/api/v2/views/${viewId}`, data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing update view: ", error);
      throw error;
    }
  },

  async deleteView(viewId) {
    try {
      let res = await transport.delete(`/api/v2/views/${viewId}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing delete view: ", error);
      throw error;
    }
  },

  async updateCurrentView(viewId) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/set-current`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing update current view: ",
        error,
      );
      throw error;
    }
  },

  async closeView(viewId) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/close`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing close view: ", error);
      throw error;
    }
  },

  async unhideView(viewId) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/unhide`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing unhide view: ", error);
      throw error;
    }
  },

  async getHiddenViews() {
    try {
      let res = await transport.get(`/api/v2/views/hidden`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing getH hidden views: ",
        error,
      );
      throw error;
    }
  },

  async updateViewSequence(data) {
    try {
      let res = await transport.post(`/api/v2/views/change-active-views`, data);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing update view sequence: ",
        error,
      );
      throw error;
    }
  },

  async shareWithWorkspace(viewId) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/share/workspace`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing share with workspace: ",
        error,
      );
      throw error;
    }
  },

  async shareWithTeams(viewId, teamIds) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/share/teams`, {
        team_ids: teamIds,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing share with teams: ",
        error,
      );
      throw error;
    }
  },

  async shareWithUsers(viewId, userIds) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/share/users`, {
        user_ids: userIds,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing share with users: ",
        error,
      );
      throw error;
    }
  },

  async shareWithTeamsAndUsers(viewId, teamIds, userIds) {
    try {
      let res = await transport.post(
        `/api/v2/views/${viewId}/share/team-and-users`,
        { team_ids: teamIds, user_ids: userIds },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing share with teams and users: ",
        error,
      );
      throw error;
    }
  },

  async unshareView(viewId) {
    try {
      let res = await transport.post(`/api/v2/views/${viewId}/unshare`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing unshare view: ", error);
      throw error;
    }
  },

  async fetchViewSharingDetails(viewId) {
    try {
      let res = await transport.get(`/api/v2/views/${viewId}/sharing-details`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing fetch view sharing details: ",
        error,
      );
      throw error;
    }
  },

  async setProjectCurrentView(projectId, viewId) {
    try {
      let res = await transport.post(
        `/api/projects/${projectId}/tasks/views/${viewId}/set-current`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while setting project current view: ", error);
      throw error;
    }
  },

  async updateProjectActiveViews(projectId, activeViewIds) {
    try {
      let res = await transport.post(
        `/api/projects/${projectId}/tasks/views/change-active-views`,
        { active_view_ids: activeViewIds },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating project active views: ", error);
      throw error;
    }
  },
};
